import React, { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import TestDatasetsPage from '../../components/cuadrantes/test';
import './datasets.scss';

const DatasetsPage = () => {
  const { currentService } = useContext(AuthContext);

  return (
    <div className="datasets-page">
      <TestDatasetsPage currentService={currentService} />
    </div>
  );
};

export default DatasetsPage; 